import {
  ImageConfig,
  ProductImage,
} from '@aboutyou/legacy-shared/src/types/images'
import { getCdnProductImageUrl } from '@aboutyou/legacy-shared/src/utils/images'
import { cdnImageUrl } from 'helpers/image'
import { IProductImage } from 'services/providers/bapi/entities/products/types'

export const imageHasGreyBackground = (image: IProductImage) => {
  return image.background === 'grey'
}

/**
 * @deprecated better use getCdnProductImageUrl
 */
export const getCdnModelImageUrl = (
  imageHash: string,
  options?: { trim?: boolean; brightness?: number },
) => {
  return cdnImageUrl(imageHash, {
    width: 800,
    height: 800,
    brightness: 0.95,
    trim: false,
    quality: 70,
    progressive: true,
    ...options,
  })
}

/**
 * @deprecated better use getCdnProductImageUrl
 */
export const getCdnThumbnailImageUrl = (imageHash: string) => {
  const options = {
    width: 100,
    height: 100,
    brightness: 0.95,
    trim: true,
    quality: 70,
    progressive: true,
  }

  return cdnImageUrl(imageHash, options)
}

export function generateSrcSet(
  productImage: ProductImage,
  widths: ImageConfig['width'][],
): string {
  return widths
    .map(width => {
      const url = getCdnProductImageUrl(productImage, {
        width,
      })
      return `${url} ${width}w`
    })
    .join(', ')
}
